// 1
import col1 from "../image/col1.webp";
import col1_1 from "../image/col1-1.webp";
import col1_2 from "../image/col1-2.webp";
import col1_3 from "../image/col1-3.webp";
import col1_4 from "../image/col1-4.webp";
import col1_5 from "../image/col1-5.webp";
import col1_6 from "../image/col1-6.webp";
import col1_7 from "../image/col1-7.webp";
import col1_8 from "../image/col1-8.webp";
import col1_9 from "../image/col1-9.webp";

// 2
import col2 from "../image/col2.webp";
import col2_1 from "../image/col2-1.webp";
import col2_2 from "../image/col2-2.webp";
import col2_3 from "../image/col2-3.webp";
import col2_4 from "../image/col2-4.webp";
import col2_5 from "../image/col2-5.webp";
import col2_6 from "../image/col2-6.webp";
import col2_7 from "../image/col2-7.webp";
import col2_8 from "../image/col2-8.webp";

// 3
import col3 from "../image/col3.webp";
import col3_1 from "../image/col3-1.webp";
import col3_2 from "../image/col3-2.webp";
import col3_3 from "../image/col3-3.jpg";
import col3_4 from "../image/col3-4.webp";
import col3_5 from "../image/col3-5.webp";
import col3_6 from "../image/col3-6.webp";
import col3_7 from "../image/col3-7.webp";
import col3_8 from "../image/col3-8.webp";
import col3_9 from "../image/col3-9.webp";
import col3_10 from "../image/col3-10.webp";

// 4
import col4 from "../image/col4.webp";
import col4_1 from "../image/col4-1.webp";
import col4_2 from "../image/col4-2.webp";
import col4_3 from "../image/col4-3.webp";
import col4_4 from "../image/col4-4.webp";
import col4_5 from "../image/col4-5.webp";
import col4_6 from "../image/col4-6.webp";
import col4_7 from "../image/col4-7.webp";
import col4_8 from "../image/col4-8.webp";
// 5
import col5 from "../image/col5.webp";
import col5_1 from "../image/col5-1.webp";
import col5_2 from "../image/col5-2.webp";
import col5_3 from "../image/col5-3.webp";
import col5_4 from "../image/col5-4.webp";
import col5_5 from "../image/col5-5.webp";
import col5_6 from "../image/col5-6.webp";
import col5_7 from "../image/col5-7.webp";
import col5_8 from "../image/col5-8.webp";

// 6
import col6 from "../image/col6.webp";
import col6_1 from "../image/col6-1.webp";
import col6_2 from "../image/col6-2.webp";
import col6_3 from "../image/col6-3.webp";
import col6_4 from "../image/col6-4.webp";
import col6_5 from "../image/col6-5.webp";
import col6_6 from "../image/col6-6.webp";
import col6_7 from "../image/col6-7.webp";

// 7
import col7 from "../image/col7.webp";
import col7_1 from "../image/col7-1.webp";
import col7_2 from "../image/col7-2.webp";
import col7_3 from "../image/col7-3.webp";
import col7_4 from "../image/col7-4.webp";
import col7_5 from "../image/col7-5.webp";
import col7_6 from "../image/col7-6.webp";
import col7_7 from "../image/col7-7.webp";
import col7_8 from "../image/col7-8.webp";
// 8
import col8 from "../image/col8.webp";
import col8_1 from "../image/col8-1.webp";
import col8_2 from "../image/col8-2.webp";
import col8_3 from "../image/col8-3.webp";
import col8_4 from "../image/col8-4.webp";
import col8_5 from "../image/col8-5.webp";
import col8_6 from "../image/col8-6.webp";
import col8_7 from "../image/col8-7.webp";

// 9
import col9 from "../image/col9.webp";
import col9_1 from "../image/col9-1.webp";
import col9_2 from "../image/col9-2.webp";
import col9_3 from "../image/col9-3.webp";
import col9_4 from "../image/col9-4.webp";
import col9_5 from "../image/col9-5.webp";
import col9_6 from "../image/col9-6.webp";

// 10
import col10 from "../image/col10.webp";
import col10_1 from "../image/col10-1.webp";
import col10_2 from "../image/col10-2.webp";
import col10_3 from "../image/col10-3.webp";
import col10_4 from "../image/col10-4.webp";
import col10_5 from "../image/col10-5.webp";
import col10_6 from "../image/col10-6.webp";
import col10_7 from "../image/col10-7.webp";

// 11
import col11 from "../image/col11.webp";
import col11_1 from "../image/col11-1.webp";
import col11_2 from "../image/col11-2.webp";
import col11_3 from "../image/col11-3.webp";
import col11_4 from "../image/col11-4.webp";
import col11_5 from "../image/col11-5.webp";
import col11_6 from "../image/col11-6.webp";
import col11_7 from "../image/col11-7.webp";

// 12
import col12 from "../image/col12.webp";
import col12_1 from "../image/col12-1.webp";
import col12_2 from "../image/col12-2.webp";
import col12_3 from "../image/col12-3.webp";
import col12_4 from "../image/col12-4.webp";
import col12_5 from "../image/col12-5.webp";
import col12_6 from "../image/col12-6.webp";
import col12_7 from "../image/col12-7.webp";
import col12_8 from "../image/col12-8.webp";

// 13
import col13 from "../image/col13.webp";
import col13_1 from "../image/col13-1.webp";
import col13_2 from "../image/col13-2.webp";
import col13_3 from "../image/col13-3.webp";
import col13_4 from "../image/col13-4.webp";
import col13_5 from "../image/col13-5.webp";
import col13_6 from "../image/col13-6.webp";

// 14
import col14 from "../image/col14.webp";
import col14_1 from "../image/col14-1.webp";
import col14_2 from "../image/col14-2.webp";
import col14_3 from "../image/col14-3.webp";
import col14_4 from "../image/col14-4.webp";
import col14_5 from "../image/col14-5.webp";
import col14_6 from "../image/col14-6.webp";
import col14_7 from "../image/col14-7.webp";

// 15
import col15 from "../image/col15.webp";
import col15_1 from "../image/col15-1.webp";
import col15_2 from "../image/col15-2.webp";
import col15_3 from "../image/col15-3.webp";
import col15_4 from "../image/col15-4.webp";
import col15_5 from "../image/col15-5.webp";
import col15_6 from "../image/col15-6.webp";
// 16
import col16 from "../image/col16.webp";
import col16_1 from "../image/col16-1.webp";
import col16_2 from "../image/col16-2.webp";
import col16_3 from "../image/col16-3.webp";
import col16_4 from "../image/col16-4.webp";
import col16_5 from "../image/col16-5.webp";
import col16_6 from "../image/col16-6.webp";
// 17
import col17 from "../image/col17.webp";
import col17_1 from "../image/col17-1.webp";
import col17_2 from "../image/col17-2.webp";
import col17_3 from "../image/col17-3.webp";
// 18
import col18 from "../image/col18.webp";
import col18_1 from "../image/col18-1.webp";
import col18_2 from "../image/col18-2.webp";
import col18_3 from "../image/col18-3.webp";
// 19
import col19 from "../image/col19.webp";
import col19_1 from "../image/col19-1.webp";
import col19_2 from "../image/col19-2.webp";
import col19_3 from "../image/col19-3.webp";
// 20
import col20 from "../image/col20.webp";
import col20_1 from "../image/col20-1.webp";
import col20_2 from "../image/col20-2.webp";
import col20_3 from "../image/col20-3.webp";

export const productList = [
  {
    category: "Men's Leather Belts",
    list: [
      {
        id: 1,
        tip: "Littlefield Chicago",
        title: `Vintage Adventure Backpack`,
        quantity: 1,
        image: [col1, col1_1, col1_2, col1_3, col1_4],
        price: 360,
        total: 360,
        ishover: false,
        descript: [
          "Discover the perfect blend of vintage charm and modern functionality with our Vintage Adventure Backpack. This classic rucksack is ideal for both men and women, offering a stylish yet practical solution for your everyday needs. Crafted from premium full grain leather, this vintage backpack only gets better with age, boasting a durable and luxurious feel. Whether you’re commuting, traveling, or exploring the great outdoors, this carry-on travel backpack has you covered.",
          "The spacious interior is designed to hold all your essentials securely while remaining easy to access. It’s the ultimate companion for those who cherish style without sacrificing functionality. Handmade by skilled artisans in La Antigua Guatemala, each Vintage Adventure Backpack features meticulous small-batch production. This means that every product is unique, reflecting the craftsmanship and dedication put into each piece. Our backpacks are hand-cut, hand-sewn, and fire branded to ensure a lasting finish that meets our high-quality standards.",
          `Not only does this backpack elevate your style, but it also tells a story of tradition and artisan work, as it is sourced from the rich natural landscapes of Petén, Guatemala. Choosing this Vintage Adventure Backpack means investing in a product that's both fashionable and sustainable. Designed for modern adventurers, this Vintage Adventure Backpack not only serves as a functional item but also as an extraordinary gift for loved ones on any special occasion. Perfectly sized for everyday use, travel, or outdoor adventures.`,
          "Dimensions",
          "Length: 9 in.",
          "Height: 20 in.",
          "Width: 6 in.",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 2,
        tip: "Littlefield Chicago",
        title: `Multipurpose Doctor Utility Tool Bag`,
        quantity: 1,
        image: [col2, col2_1, col2_2, col2_3, col2_4],
        price: 230,
        total: 230,
        ishover: false,
        descript: [
          `Introducing the ultimate solution for professionals: the Multipurpose Doctor Utility Tool Bag by Littlefield Chicago. This tool bag is not just a carry-all; it’s a blend of functionality and elegance, designed for those who demand excellence in their work. Whether you're a doctor transporting medical instruments or a handyman carrying essential tools, this bag adapts effortlessly to your needs.`,
          `Crafted from high-quality full-grain leather, this bag boasts a vintage style that makes a statement in any professional environment. It’s perfect for those who appreciate not only functionality but also the charm of traditional craftsmanship. With the Multipurpose Doctor Utility Tool Bag, you not only carry your tools but also elevate your professional image, showcasing your commitment to quality.`,
          `Durability is at the forefront of this design. Equipped with a robust 3.5mm thick leather bottom, this bag offers unparalleled protection. Your valuable tools will remain safe from impact during transportation, giving you peace of mind while you focus on your tasks. You can tackle the toughest environments with confidence, knowing your gear is well protected.`,
          `Organization is key to productivity, and this tool bag excels in this area. It features a smart layout that reduces search time and enables quick access to your tools. You’ll be empowered to complete your tasks with ease and precision, making your workday smoother and more efficient.`,
          `The minimalist design ensures that this tool bag is not just practical but visually appealing as well. Its sleek lines and refined simplicity foster a clutter-free environment, inspiring creativity and focus. Let every tool have its place, promoting organization in your workspace that matches your professional ethos.`,
          "Dimensions",
          "Length: 16 in.",
          "Height: 6.2 in.",
          "Width: 6 in.",
          "Materials: Full Grain Leather",
          "Over time, the leather of your Multipurpose Doctor Utility Tool Bag will develop a unique patina, reflecting your journey and experiences. For care, simply condition it with mineral oil or beeswax leather conditioner to maintain its beauty and longevity. Experience the blend of style and functionality with the Multipurpose Doctor Utility Tool Bag today!",
        ],
      },
      {
        id: 3,
        tip: "Littlefield Chicago",
        title: `Classic Portfolio`,
        quantity: 1,
        image: [col3, col3_1, col3_2, col3_3, col3_4],
        price: 252,
        total: 252,
        ishover: false,
        descript: [
          `PRODUCT DESCRIPTION: Our document holder is a versatile and practical solution for storing and transporting your essential papers and materials. Our portfolio's rustic design and rugged construction add a touch of character to your professional attire, making you stand out with timeless style and sophistication. Featuring handles for easy carrying and a zipper closure for added security, our padfolio keeps your documents, notebooks, and essentials organized and protected while on the go.`,
          `MATERIAL TYPE: Full Grain Leather - Inspired by classic designs and timeless aesthetics, our products exude an air of timeless elegance that never goes out of style, making them a worthy investment for years to come. Elevate your style and make a statement with our Full Grain Leather products, designed to complement any outfit and leave a lasting impression wherever you go.`,
          `MATERIAL ORIGIN: Petén, Guatemala - our high quality, full grain leather is sourced locally in the beautiful department of Petén. Known all over the world for its colossal ancient Mayan ruins, dense rainforest, and elusive wildlife, Peten is not only a place of spectacular wonders, but it's also a trade hub for unique raw materials, and proudly bears the status of a perfect example of modern and traditional Guatemala, bursting with tradition and beauty.`,
          `MAKER LOCATION: Antigua, Guatemala - Here at Littlefield Chicago, each of our products is handmade by local artisans in Antigua, Guatemala, a town renowned for its craftsmanship. We hand-cut and finely hand stitch our products using a tried-and-true method, resulting in a durable finish and a lifetime of use. Any loose ends are passed over with an open flame to prevent any unravelling.`,
          `MAKES A GREAT GIFT + LIFETIME GUARANTEE: Littlefield Chicago. proudly stands behind its products and knows that this unique, handcrafted product will make an excellent gift for friends, family, and loved ones, whether for birthdays, Christmas, or any special occasion. What's more, we offer a 100% Lifetime Customer Satisfaction Guarantee, so if you are not satisfied with your purchase at any point, just get in touch with us and we'll make it right.`,
          "SPECIFICATIONS",
          "Dimensions",
          "Length: 15 in.",
          "Height: 11 in.",
          "Width: 2 in.",
          "Materials",
          "Full Grain Leather",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 4,
        tip: "Littlefield Chicago",
        title: `Vintage Tote Vertical Briefcase & Laptop Carrier`,
        quantity: 1,
        image: [col4, col4_1, col4_2, col4_3, col4_4],
        price: 349,
        total: 349,
        ishover: false,
        descript: [
          "Experience the perfect blend of elegance and functionality with our Vintage Tote Vertical Briefcase & Laptop Carrier. Designed for those who appreciate both style and practicality, this bag is the ultimate accessory for casual outings, work environments, and weekend adventures. Its rustic charm makes it an ideal choice whether you’re heading to the office or off to travel.",
          "The Vintage Tote features a detachable, adjustable shoulder strap, allowing you to carry it as a traditional tote or effortlessly switch to a shoulder bag. With ample space, it accommodates laptops, documents, and all your everyday essentials with ease. Enjoy versatile carrying options that adapt to your lifestyle, ensuring you look good while staying organized.",
          "Every Vertical Briefcase & Laptop Carrier is handmade from exceptional full grain leather. Each piece reflects artisan craftsmanship, as our bags are hand cut, hand sewn, and fire branded, showcasing the dedication of our skilled makers in La Antigua Guatemala and Oaxaca Mexico.",
          "This bag doubles as an easy access bag perfect for work, travel, and weekend getaways comes with spacious interior fits laptops and documents. With small batch production techniques, we ensure that each item is crafted meticulously, reflecting our commitment to quality and excellence.",
          "Dimensions",
          "Length: 13.75 in.",
          "Height: 14.5 in.",
          "Width: 3 in.",
          "USE & CARE",
          "This unique handcrafted bag makes a great gift for friends, family, or even yourself. Invest in style and functionality with the Vintage Tote Vertical Briefcase & Laptop Carrier today!",
        ],
      },
      {
        id: 5,
        tip: "Littlefield Chicago",
        title: `Large Vintage Weekender Bag`,
        quantity: 1,
        image: [col5, col5_1, col5_2, col5_3, col5_4, col5_5],
        price: 420,
        total: 420,
        ishover: false,
        descript: [
          "Discover the perfect travel companion with our Large Vintage Weekender Bag. This beautifully crafted duffle weekender bag seamlessly blends timeless style with practicality. Inspired by classic designs, it adds a touch of sophistication to your travels and ensures you make a statement wherever you go.",
          "With its generous size, this vintage carry-on bag is perfect for weekend getaways, short trips, or as a chic carry-on for longer journeys. Its ample space allows you to pack all your travel essentials comfortably. Plus, the detachable shoulder strap gives you versatility in carrying options; you can choose to either carry it by hand or slung over your shoulder for comfort.",
          "Crafted from high-quality full grain leather, our large vintage weekender bag not only looks stunning but is also built to last. Handmade in La Antigua Guatemala and Oaxaca Mexico, this bag supports small batch production, ensuring each piece is made with care by artisans. It features fire branded details, showcasing our commitment to quality craftsmanship and attention to detail.",
          "Dimensions",
          "Length: 19 in.",
          "Height: 13 in.",
          "Width: 9 in.",
          "USE & CARE",
          "Care for your bag by conditioning it over time with mineral oil or beeswax leather conditioner to maintain its rich texture. Our large vintage weekender bag is not just luggage; it’s a piece of art crafted with love and dedication, designed for those who appreciate tradition and quality.",
        ],
      },
      {
        id: 6,
        tip: "Littlefield Chicago",
        title: `Vintage Rucksack`,
        quantity: 1,
        image: [col6, col6_1, col6_2, col6_3, col6_4],
        price: 395,
        total: 395,
        ishover: false,
        descript: [
          "PRODUCT DESCRIPTION: A vintage style that suits both men and women, perfect for those who appreciate a timeless aesthetic. It is ideal for travel, daily commutes, and outdoor adventures, serving as a reliable carry-on travel backpack. It combines practicality with a vintage look, making it perfect for professionals and travelers.",
          "MATERIAL TYPE: Full Grain Leather - Inspired by classic designs and timeless aesthetics, our products exude an air of timeless elegance that never goes out of style, making them a worthy investment for years to come. Elevate your style and make a statement with our Full Grain Leather products, designed to complement any outfit and leave a lasting impression wherever you go.",
          `MATERIAL ORIGIN: Petén, Guatemala - our high-quality, full-grain leather is sourced locally in the beautiful department of Petén. Known all over the world for its colossal ancient Mayan ruins, dense rainforest, and elusive wildlife, Peten is not only a place of spectacular wonders, but it's also a trade hub for unique raw materials, and proudly bears the status of a perfect example of modern and traditional Guatemala, bursting with tradition and beauty.`,
          "MAKER LOCATION: Antigua, Guatemala - Here at Littlefield Chicago, each of our products is handmade by local artisans in Antigua, Guatemala, a town renowned for its craftsmanship. We hand-cut and finely hand stitch our products using a tried-and-true method, resulting in a durable finish and a lifetime of use. Any loose ends are passed over with an open flame to prevent any unraveling.",
          `MAKES A GREAT GIFT + LIFETIME GUARANTEE: Littlefield Chicago proudly stands behind its products and knows that this unique, handcrafted product will make an excellent gift for friends, family and loved ones, whether for birthdays, Christmas, or any special occasion. What's more, we offer a 100% Lifetime Customer Satisfaction Guarantee, so if you are not satisfied with your purchase at any point, just get in touch with us, and we'll make it right.`,
          "SPECIFICATIONS",
          "Dimensions",
          "Length: 17 in.",
          "Height: 20 in.",
          "Width: 12 in.",
          "Materials",
          "Full Grain Leather",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 7,
        tip: "Littlefield Chicago",
        title: `Vintage Mail Carrier Weekend Duffle`,
        quantity: 1,
        image: [col7, col7_1, col7_2, col7_3, col7_4],
        price: 289,
        total: 289,
        ishover: false,
        descript: [
          "Introducing the Vintage Mail Carrier Weekend Duffle, a perfect blend of classic style and modern functionality! This vintage-inspired mail carrier bag is perfect for those who appreciate a touch of nostalgia while seeking a reliable bag for daily use. Crafted from premium full grain leather, it offers durability and a sleek appearance that only gets better with age.",
          `The Vintage Mail Carrier Weekend Duffle is designed with practicality in mind. It features a spacious interior that easily accommodates laptops, documents, notebooks, and all your daily essentials. Whether you're a busy professional commuting to the office or a traveler on an exciting adventure, this versatile messenger bag adapts effortlessly to your lifestyle. The adjustable shoulder strap allows for comfortable carrying as a crossbody bag, making it ideal for anyone on the go.`,
          `Each piece of this artisan-crafted bag is hand cut and hand sewn by skilled artisans in La Antigua, Guatemala, ensuring that you receive a unique product with every purchase. The fire-branded logo adds a distinctive touch, making this large briefcase not just a bag, but a statement piece! Spacious design perfect for laptops, documents, and more.`,
          `Make a statement with this stylish, functional bag, perfect for any occasion. Ready to elevate your accessory game? Order yours today! Explore the perfect blend of tradition and modern craftsmanship with Littlefield Chicago. Choose the Vintage Mail Carrier Weekend Duffle and carry your essentials with style!`,
          "Dimensions",
          "Length: 17 in.",
          "Height: 13 in.",
          "Width: 5 in.",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 8,
        tip: "Littlefield Chicago",
        title: `Compact Crossbody Bag`,
        quantity: 1,
        image: [col8, col8_1, col8_2, col8_3, col8_4],
        price: 218,
        total: 218,
        ishover: false,
        descript: [
          "PRODUCT DESCRIPTION: Our Compact Crossbody Bag combines style and functionality, offering a versatile accessory for your travels or everyday use. Designed with an adjustable strap, our bag can be worn as a crossbody or messenger bag, providing comfort and convenience for carrying your essentials. Our Compact Bag is cleverly designed with practical compartments and secure zippers, ensuring your essentials are always within reach without sacrificing style. This bag not only adds a touch of sophistication to any outfit but is also an indispensable accessory for anyone who appreciates style and efficiency combined. ",
          "MATERIAL TYPE: Full Grain Leather - Inspired by classic designs and timeless aesthetics, our products exude an air of timeless elegance that never goes out of style, making them a worthy investment for years to come. Elevate your style and make a statement with our Full Grain Leather products, designed to complement any outfit and leave a lasting impression wherever you go.",
          `MATERIAL ORIGIN: Petén, Guatemala - our high-quality, full-grain leather is sourced locally in the beautiful department of Petén. Known all over the world for its colossal ancient Mayan ruins, dense rainforest, and elusive wildlife, Peten is not only a place of spectacular wonders, but it's also a trade hub for unique raw materials, and proudly bears the status of a perfect example of modern and traditional Guatemala, bursting with tradition and beauty.`,
          "MAKER LOCATION: Antigua, Guatemala - Here at Littlefield Chicago, each of our products is handmade by local artisans in Antigua, Guatemala, a town renowned for its craftsmanship. We hand-cut and finely hand-stitch our products using a tried-and-true method, resulting in a durable finish and a lifetime of use. Any loose ends are passed over with an open flame to prevent any unravelling.",
          `MAKES A GREAT GIFT + LIFETIME GUARANTEE: Littlefield Chicago. proudly stands behind its products and knows that this unique, handcrafted product will make an excellent gift for friends, family, and loved ones, whether for birthdays, Christmas, or any special occasion. What's more, we offer a 100% Lifetime Customer Satisfaction Guarantee, so if you are not satisfied with your purchase at any point, just get in touch with us, and we'll make it right.`,
          "SPECIFICATIONS",
          "Dimensions",
          "Length: 11.5 in.",
          "Height: 6 in.",
          "Width: 5.25 in.",
          "Materials",
          "Full Grain Leather",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 9,
        title: "Multipurpose Taco Wallet",
        quantity: 1,
        price: 70,
        total: 70,
        image: [col9, col9_1, col9_2, col9_3],
        descript: [
          `Introducing the amazing Multipurpose Taco Wallet by Hide & Drink, the ultimate handmade wallet that seamlessly combines style and functionality. Crafted from premium Full Grain Leather, this wallet is built to endure while adding a delightful touch of charm to your accessory collection. Whether it's Taco Tuesday or just a casual outing, this wallet proves to be perfect for every occasion.`,
          `The Taco Wallet stands out not only for its aesthetic appeal but also for its exceptional craftsmanship. Each wallet is meticulously handmade by skilled artisans in Guatemala, ensuring that every piece is unique and embodies the true spirit of artisanal craft. The combination of soft and durable suede leather with robust Full Grain Leather offers an unbeatable mix of strength and elegance. It's more than just a wallet; it's a statement piece.`,
          "Every detail of this wallet has been thoughtfully designed. The rustic yet classy look makes it suitable for both everyday use and special occasions. Plus, it makes an excellent gift for friends, family, or anyone who appreciates quality craftsmanship. Built to last a lifetime, the Taco Wallet will serve as a timeless addition to your collection.",
          "Dimensions:",
          "Length: 7.50 in.",
          "Height: 5 in.",
          "Width: 1.5 in.",
          "Materials:",
          "Full Grain Leather & Suede Leather",
          "Use & Care:",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 10,
        title: "Curved EDC Pocket Wallet",
        quantity: 1,
        price: 49,
        total: 49,
        image: [col10, col10_1, col10_2, col10_3],
        descript: [
          "Introducing the EDC Pocket Wallet, the ultimate companion for the modern minimalist. Slim, sleek, and stylish, this wallet is designed for those who value both aesthetics and functionality. Crafted from premium Full Grain Leather, this wallet is a testament to durability and style.",
          "Hide & Drink, known for quality craftsmanship, brings you this exquisite EDC Pocket Wallet featuring a curved cash organizer and a reliable money clip. Hand cut and hand sewn by skilled artisans in La Antigua Guatemala and Oaxaca Mexico, each piece represents a commitment to excellence in small batch production.",
          `The EDC Pocket Wallet not only holds your essentials but also evolves with you. This wallet is more than just an accessory; it’s a reflection of your lifestyle. Whether you’re heading to the office or out for a night on the town, the EDC Pocket Wallet offers functionality without sacrificing style. It's the perfect gift for anyone who appreciates fine craftsmanship and practical design.`,
          "Each wallet is meticulously crafted using top-quality materials to ensure longevity and durability. Designed to maximize space, it easily fits in your front pocket while securely holding your cash and cards. Experience the blend of tradition and innovation with the EDC Pocket Wallet. Say goodbye to bulky wallets and embrace a lean, functional design that complements your lifestyle.",
          "Dimensions",
          "Length: 5 in.",
          "Width: 3.63 in.",
          "Height: 0.50 in.",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 11,
        title: "Long Utility Pouch",
        quantity: 1,
        price: 38,
        total: 38,
        image: [col11, col11_1, col11_2, col11_3],
        descript: [
          "Introducing the Long Utility Pouch from Hide & Drink, the quintessential accessory for those who value style and function. Handcrafted by artisans in La Antigua Guatemala and Oaxaca, Mexico, this pouch showcases the beauty of fine craftsmanship combined with the durability of full grain leather. Each Long Utility Pouch is made to last, promising years of reliable use",
          `This stylish wallet is designed for carrying and storing essentials like cash, coins, and cards with ease. Its minimalist vintage style complements any outfit or bag, making it a versatile addition to your collection. Whether you're heading out for a casual day or a formal event, this pouch will enhance your look while keeping your items organized.`,
          "Every Long Utility Pouch is a testament to quality. Crafted via small batch production, each pouch is meticulously hand cut and hand sewn with precision. The expert artisans pay close attention to detail, incorporating fine stitching that not only looks stunning but ensures longevity.",
          "The Long Utility Pouch makes a thoughtful gift for anyone who appreciates fine leather goods. With its rustic charm and robust build, it is perfect for birthdays, anniversaries, or simply to spoil yourself. Trust in the quality and artistry of Hide & Drink’s creations and make this Long Utility Pouch a staple in your accessory lineup today!",
          "Dimensions",
          "Length: 7.88 in.",
          "Height: 3.5 in.",
          "Width: 0.38 in.",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 12,
        title: "Ontario Premium Bison Bifold with ID Window",
        quantity: 1,
        price: 65,
        total: 65,
        image: [col12, col12_1, col12_2, col12_3],
        descript: [
          "Introducing the Large Zippered Wallet, the ultimate travel accessory for men and women. Crafted from premium Full Grain Leather, this wallet offers a unique blend of style and functionality. Measuring 8.5 x 4.5 inches, it is designed to keep all of your essential items organized. You can easily store up to 8 cards, coins and flat bills, ensuring you never misplace your travel essentials!",
          `This Long Zippered Wallet isn't just a product; it's a masterpiece, handmade in La Antigua Guatemala and Oaxaca, Mexico. Each wallet is meticulously hand cut and hand sewn by skilled artisans. You can trust that every stitch is crafted with care, producing a durable finish that withstands the test of time.`,
          "The beautiful Full Grain Leather used in this wallet guarantees a lasting quality. As you use it, the leather will develop a unique patina that adds character and charm. Whether you choose the sophisticated Bourbon Brown, sleek Charcoal Black, or vibrant Sangria, you’ll own a wallet that stands out.",
          "The Large Zippered Wallet is not just an accessory; it makes for a thoughtful gift for friends and family. Show your loved ones you care with a product that is built to last a lifetime. Elevate your daily carry with this exquisite card organizer and bill holder!",
          "Dimensions",
          "Length: 8.5 in.",
          "Height: 4.5 in.",
          "Width: 0.75 in.",
          "Materials",
          "Full Grain Leather",
          "USE & CARE",
          "Over time, your leather will take on a distinctive patina. To maintain its beauty, consider conditioning with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 17,
        title: "Vintage Leather Golf Bag",
        quantity: 1,
        price: 439,
        total: 439,
        image: [col17, col17_1, col17_2, col17_3],
        descript: [
          `Introducing the Vintage Leather Golf Bag, the ultimate accessory for golf enthusiasts who value style and functionality. Handcrafted from premium full grain leather, this golf bag is designed to offer both durability and elegance. Whether you're hitting the greens for a casual day or participating in a competitive tournament, this bag provides the perfect blend of classic aesthetics and contemporary functionality.`,
          `Our Vintage Leather Golf Bag is not only visually appealing but also practical. It features a top divider that ensures your clubs are organized and easily accessible. The adjustable shoulder strap provides comfort while carrying, making it perfect for walking the course or transporting your gear.`,
          `Crafted with love by skilled artisans in La Antigua, Guatemala, each bag is a testament to quality craftsmanship. We pride ourselves on our small batch production methods, which allow us to focus on the details that make all the difference. Every bag undergoes a meticulous hand-cutting and hand-stitching process, ensuring a product that's not only beautiful but built to last.`,
          `Elevate your golf game and showcase your style with our Vintage Leather Golf Bag. Experience the perfect blend of tradition and modern design, sure to turn heads on the course.`,
          "Dimensions",
          "Length: 7.5 in.",
          "Height: 35 in.",
          "Width: 7.5 in.",
          "USE & CARE",
          "This golf bag tells a story of adventure and style. We recommend conditioning it with mineral oil or beeswax leather conditioner to maintain its stunning appearance. This bag makes an excellent gift for both men and women, perfect for birthdays or special occasions.",
        ],
      },
      {
        id: 18,
        title: "Lightweight Travel Golf Bag with Protective Rain Hood",
        quantity: 1,
        price: 380,
        total: 380,
        image: [col18, col18_1, col18_2, col18_3],
        descript: [
          `RETRO SHIELD: This water-resistant, retro-inspired golf club travel bag ensures your clubs. Tailored for the discerning golfer, it offers a chic and functional solution for safeguarding your precious equipment against unexpected drizzles and splashes. With its blend of form and function, this small golf travel bag adds a touch of sophistication to every outing, making it an indispensable companion on and off the green.`,
          `CLUB FREEDOM: This lightweight golf bag makes every round a breeze; engineered to carry a few clubs comfortably, it is perfect for golfers who love walking courses without fatigue. Its sleek design ensures you move gracefully and effortlessly, transforming your golfing routine into an enjoyable, hassle-free experience. Revel in the freedom offered by being unburdened by heavy equipment, enhancing your connection with the game; a must-have for any golf enthusiast seeking simplicity and style.`,
          `SUNDAY SPEED: Meet the ultimate driving range golf bag for those spontaneous mornings on the green. Crafted for efficiency, this Sunday golf bag lets you grab your essentials and go. Designed with the casual golfer in mind, it offers a balance of utility and ease, making it the perfect accessory for effortless games and practice sessions.`,
          `CANVAS ARMOR: Handmade from water-resistant canvas, this collapsible golf bag withstands the test of time and travel. Handmade to protect against wear and tear without sacrificing aesthetic appeal. It is perfect for the golfer who refuses to compromise on craftsmanship or practicality. Relish in a sophisticated yet sturdy solution that ensures your small golf bag remains as robust and attractive as the day you bought it, enhancing every golfing adventure with reliability and elegance.`,
          `DETACHABLE COMFORT: Enjoy ultimate flexibility with the detachable leather shoulder strap; this feature effortlessly transforms the small golf bag from shoulder to hand-carry, accommodating your travel style and comfort preferences. The luxury leather strap offers premium comfort when navigating busy airports or strolling the fairway. It easily adapts to your carrying needs, ensuring you experience ease and sophistication while managing your golf essentials.`,
          "SPECIFICATIONS",
          "Dimensions",
          "Height: 33 in.",
          "Materials",
          "Full Grain Leather",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 19,
        title: "Vintage Sunday Carry Golf Bag",
        quantity: 1,
        price: 356,
        total: 356,
        image: [col19, col19_1, col19_2, col19_3],
        descript: [
          `Elevate your golfing experience with the Vintage Sunday Carry Golf Bag, a masterpiece of craftsmanship and style. This artisanal bag is designed not only to carry your clubs but also to reflect your passion for the game. Handmade in La Antigua Guatemala and Oaxaca Mexico, it combines vintage aesthetics with modern functionality, making it a standout choice among men's basic bags for golf clubs.`,
          "Crafted from thick full grain leather, this golf bag promises unparalleled durability. Its luxurious materials age beautifully, developing a unique patina over time while resisting wear and tear. Emphasize your status on the golf course with a bag that speaks of sophistication and endurance. Choose this Vintage Carry Golf Bag with Shoulder Strap to ensure that your golfing gear is both stylish and practical.",
          "The structure of the Vintage Sunday Carry Golf Bag is impeccable. Featuring a top reinforced with internal metal support, it maintains its shape season after season. Forget about sagging or compromised aesthetics. Our lightweight caddie golfing gear allows for effortless movement as you navigate the course, whether walking or using a golf cart.",
          "With a focus on comfort, this bag is equipped with a padded shoulder strap and balanced weight distribution. This means you can easily carry your clubs without straining your back, giving you the freedom to concentrate on your game. Enjoy the ergonomic design that redefines how you view traditional standing carry golf bags.",
          "Every aspect, from hand-cut leather to fire-branded details, speaks of a dedication to quality and craftsmanship. Discover the ultimate blend of form and function with the Vintage Sunday Carry Golf Bag, your perfect companion for every round of golf.",
          "Dimensions",
          "Height: 33 in.",
          "Diameter: 5 in.",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
      {
        id: 20,
        title: "Par 3 Practice Wedge Golf Club Carrier",
        quantity: 1,
        price: 160,
        total: 160,
        image: [col20, col20_1, col20_2, col20_3],
        descript: [
          "ENDURING CLASS: Handmade from water-resistant canvas and full-grain leather, this golf club carrier ensures longevity while exuding timeless elegance. The detachable shoulder strap provides versatile carrying options, enhancing comfort and convenience. Perfect for golfers who seek a practical yet sophisticated small golf bag for a few clubs, it ensures every round is played with ease and clas",
          "EFORTLESS ELEGANCE: This golf club carrier makes transporting your clubs a breeze with a detachable strap and lightweight design, perfect for those who prefer to travel light. Whether using it as a driving range golf bag or heading out for a quick round, relish the ease of carrying without sacrificing your elegant aesthetic. This carrier elevates your golfing experience, ideal for golfers who cherish both convenience and the luxury of a premium, handmade piece.",
          "SUNDAY SOPHISTICATION: With this golf club carrier, enjoy the artisanal excellence of handmade design while utilizing its practicality for every round. Known for being an elegant yet efficient golfing companion, it is the ideal Sunday golf bag for lightweight yet resilient club storage; perfect for those who prioritize aesthetic appeal and robust functionality in a small golf club holder.",
          "COLLAPSIBLE CLASS: This golf club carrier is not only a statement piece but is also designed for seamless transitions between the course and practice sessions; the collapsible feature allows easy storage, fitting perfectly into any travel golf bag set, ensuring protection and style wherever your game takes you. Ideal for those seeking a versatile, small golf travel bag without forgoing elegance and full functionality.",
          "RANGE REFINED: This driving range golf bag adapts to various golfing scenarios, whether a full day at the course or a quick practice session. Its collapsible design makes it easy to store and perfect for travel, making it a must-have companion for golfers who value convenience and style without compromise.",
          "SPECIFICATIONS",
          "Materials",
          "Full Grain Leather & Water Resistant Canvas",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
        ],
      },
    ],
  },
  {
    category: "You may also like",
    list: [
      {
        id: 13,
        title: "Two Row Stitch Thick Leather Belt",
        quantity: 1,
        price: 49,
        total: 49,
        image: [col13, col13_1, col13_2],
        sku: [
          {
            title: "Size",
            list: [
              '22"',
              '24"',
              '26"',
              '28"',
              '30"',
              '32"',
              '34"',
              '36"',
              '38"',
              '40"',
            ],
          },
        ],
        checked: '22"',
        descript: [
          "Handmade from Full Grain Leather",
          "Simple and Classy Design",
          "Double Row Stitching and Sturdy Metal Buckle",
          "Built to Last",
          "Made By Local Artisans From Pastores, Sacatepequez ",
          "See Below for Belt Sizing Advice",
          "SPECIFICATIONS",
          "Dimensions",
          "Lengths available from 20 Inch up to 50 Inch Waist",
          "Height: 1.5 Inches",
          "Width: 0.2 Inches",
          "Materials",
          "Full Grain Leather, Brass Metal Buckle",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
          "PRODUCTION & DESIGN",
          `No outfit is complete without a finely crafted leather belt to bring it all together, and when buying a belt, you need to look for quality. Hide & Drink's Men's Leather Belt is the perfect addition to your wardrobe, and with its two-row stitching and heavy-duty buckle, this handmade belt is set to stand the test of time.`,
          `Belts have long been used with clothing as far back as the Bronze Age. They were popular with army uniforms, especially so with the armies of Eastern Europe and Russia, who would wear tight belts to reduce waist size and improve stature. They even went as far as wearing a corset, which is where we draw the line. In the past, belts were more popular among men than women, but as time progressed, the belt has become equally a fashion statement for both sexes. Celebrate the history of such a fine accessory with the Men's Leather Belt by Hide & Drink.`,
        ],
      },
      {
        id: 14,
        title: "Two Row Stitch Thick Leather Belt",
        quantity: 1,
        price: 49,
        total: 49,
        image: [col14, col14_1, col14_2],
        sku: [
          {
            title: "Size",
            list: [
              '22"',
              '24"',
              '26"',
              '28"',
              '30"',
              '32"',
              '34"',
              '36"',
              '38"',
              '40"',
            ],
          },
        ],
        checked: '22"',
        descript: [
          "Handmade from Full Grain Leather",
          "Simple and Classy Design",
          "Double Row Stitching and Sturdy Metal Buckle",
          "Built to Last",
          "Made By Local Artisans From Pastores, Sacatepequez ",
          "See Below for Belt Sizing Advice",
          "SPECIFICATIONS",
          "Dimensions",
          "Lengths available from 20 Inch up to 50 Inch Waist",
          "Height: 1.5 Inches",
          "Width: 0.2 Inches",
          "Materials",
          "Full Grain Leather, Brass Metal Buckle",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
          "PRODUCTION & DESIGN",
          `No outfit is complete without a finely crafted leather belt to bring it all together, and when buying a belt, you need to look for quality. Hide & Drink's Men's Leather Belt is the perfect addition to your wardrobe, and with its two-row stitching and heavy-duty buckle, this handmade belt is set to stand the test of time.`,
          `Belts have long been used with clothing as far back as the Bronze Age. They were popular with army uniforms, especially so with the armies of Eastern Europe and Russia, who would wear tight belts to reduce waist size and improve stature. They even went as far as wearing a corset, which is where we draw the line. In the past, belts were more popular among men than women, but as time progressed, the belt has become equally a fashion statement for both sexes. Celebrate the history of such a fine accessory with the Men's Leather Belt by Hide & Drink.`,
        ],
      },
      {
        id: 15,
        title: "Two Row Stitch Thick Leather Belt - Antique Brass Buckle",
        quantity: 1,
        price: 49,
        total: 49,
        image: [col15, col15_1, col15_2],
        sku: [
          {
            title: "Size",
            list: [
              '22"',
              '24"',
              '26"',
              '28"',
              '30"',
              '32"',
              '34"',
              '36"',
              '38"',
              '40"',
            ],
          },
        ],
        checked: '22"',
        descript: [
          "Handmade from Full Grain Leather",
          "Simple and Classy Design",
          "Double Row Stitching and Sturdy Metal Buckle",
          "Built to Last",
          "Made By Local Artisans From Pastores, Sacatepequez ",
          "See Below for Belt Sizing Advice",
          "SPECIFICATIONS",
          "Dimensions",
          "Lengths available from 20 Inch up to 50 Inch Waist",
          "Height: 1.5 Inches",
          "Width: 0.2 Inches",
          "Materials",
          "Full Grain Leather, Brass Metal Buckle",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
          "PRODUCTION & DESIGN",
          `No outfit is complete without a finely crafted leather belt to bring it all together, and when buying a belt, you need to look for quality. Hide & Drink's Men's Leather Belt is the perfect addition to your wardrobe, and with its two-row stitching and heavy-duty buckle, this handmade belt is set to stand the test of time.`,
          `Belts have long been used with clothing as far back as the Bronze Age. They were popular with army uniforms, especially so with the armies of Eastern Europe and Russia, who would wear tight belts to reduce waist size and improve stature. They even went as far as wearing a corset, which is where we draw the line. In the past, belts were more popular among men than women, but as time progressed, the belt has become equally a fashion statement for both sexes. Celebrate the history of such a fine accessory with the Men's Leather Belt by Hide & Drink.`,
        ],
      },
      {
        id: 16,
        title: "Two Row Stitch Thick Leather Belt - Antique Brass Buckle",
        quantity: 1,
        price: 49,
        total: 49,
        image: [col16, col16_1, col16_2],
        sku: [
          {
            title: "Size",
            list: [
              '22"',
              '24"',
              '26"',
              '28"',
              '30"',
              '32"',
              '34"',
              '36"',
              '38"',
              '40"',
            ],
          },
        ],
        checked: '22"',
        descript: [
          "Handmade from Full Grain Leather",
          "Simple and Classy Design",
          "Double Row Stitching and Sturdy Metal Buckle",
          "Built to Last",
          "Made By Local Artisans From Pastores, Sacatepequez ",
          "See Below for Belt Sizing Advice",
          "SPECIFICATIONS",
          "Dimensions",
          "Lengths available from 20 Inch up to 50 Inch Waist",
          "Height: 1.5 Inches",
          "Width: 0.2 Inches",
          "Materials",
          "Full Grain Leather, Brass Metal Buckle",
          "USE & CARE",
          "Over time and with use, the leather will assume a unique patina. If desired, condition with mineral oil or beeswax leather conditioner.",
          "PRODUCTION & DESIGN",
          `No outfit is complete without a finely crafted leather belt to bring it all together, and when buying a belt, you need to look for quality. Hide & Drink's Men's Leather Belt is the perfect addition to your wardrobe, and with its two-row stitching and heavy-duty buckle, this handmade belt is set to stand the test of time.`,
          `Belts have long been used with clothing as far back as the Bronze Age. They were popular with army uniforms, especially so with the armies of Eastern Europe and Russia, who would wear tight belts to reduce waist size and improve stature. They even went as far as wearing a corset, which is where we draw the line. In the past, belts were more popular among men than women, but as time progressed, the belt has become equally a fashion statement for both sexes. Celebrate the history of such a fine accessory with the Men's Leather Belt by Hide & Drink.`,
        ],
      },
    ],
  },
];

export const getProductDetailById = (id) => {
  let product;
  for (const item of productList) {
    product = item.list.find((itemProduct) => itemProduct.id === id);
    if (product) return product;
  }
  return undefined;
};

// find
export const getCategoryList = (type) => {
  let list = productList.find((item) => item.category === type);
  return list;
};
